/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Page_CountInputs */

const en_field_page_count = /** @type {(inputs: Field_Page_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Page Count`)
};

/** @type {(inputs: Field_Page_CountInputs) => LocalizedString} */
const es_field_page_count = en_field_page_count;

/** @type {(inputs: Field_Page_CountInputs) => LocalizedString} */
const fr_field_page_count = en_field_page_count;

/** @type {(inputs: Field_Page_CountInputs) => LocalizedString} */
const de_field_page_count = en_field_page_count;

/** @type {(inputs: Field_Page_CountInputs) => LocalizedString} */
const ja_field_page_count = en_field_page_count;

/** @type {(inputs: Field_Page_CountInputs) => LocalizedString} */
const zh_field_page_count = en_field_page_count;

/** @type {(inputs: Field_Page_CountInputs) => LocalizedString} */
const ar_field_page_count = en_field_page_count;

/** @type {(inputs: Field_Page_CountInputs) => LocalizedString} */
const id_field_page_count = en_field_page_count;

/** @type {(inputs: Field_Page_CountInputs) => LocalizedString} */
const it_field_page_count = en_field_page_count;

/** @type {(inputs: Field_Page_CountInputs) => LocalizedString} */
const ru_field_page_count = en_field_page_count;

/** @type {(inputs: Field_Page_CountInputs) => LocalizedString} */
const pt_field_page_count = en_field_page_count;

/** @type {(inputs: Field_Page_CountInputs) => LocalizedString} */
const ko_field_page_count = en_field_page_count;

/**
* | output |
* | --- |
* | "Page Count" |
*
* @param {Field_Page_CountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_page_count = /** @type {((inputs?: Field_Page_CountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Page_CountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_page_count(inputs)
	if (locale === "es") return es_field_page_count(inputs)
	if (locale === "fr") return fr_field_page_count(inputs)
	if (locale === "de") return de_field_page_count(inputs)
	if (locale === "ja") return ja_field_page_count(inputs)
	if (locale === "zh") return zh_field_page_count(inputs)
	if (locale === "ar") return ar_field_page_count(inputs)
	if (locale === "id") return id_field_page_count(inputs)
	if (locale === "it") return it_field_page_count(inputs)
	if (locale === "ru") return ru_field_page_count(inputs)
	if (locale === "pt") return pt_field_page_count(inputs)
	return ko_field_page_count(inputs)
});